function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { actions as modalActions } from '../../reducers/modal.reducer';
import { actions as ppcActions } from '../../reducers/ppc.reducer';
import PpcPagesAdd from './add/PpcPagesAdd.modal';
import Table from '../common/table/Table.react';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';

// TODO :: Stop if app / type is not in constants
var PagesTable = function PagesTable() {
  var navigate = useNavigate();
  var _useParams = useParams(),
    app = _useParams.app,
    itemID = _useParams.itemID;
  var dispatch = useDispatch();
  var page = useSelector(function (s) {
    return s.ppc.page.index;
  });
  var cmsNavigation = useSelector(function (s) {
    return s.cms.navigation || {};
  });
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    pagesArr = _useState2[0],
    setPagesArr = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    tableData = _useState4[0],
    setTableData = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    filter = _useState6[0],
    setFilter = _useState6[1];
  useEffect(function () {
    dispatch({
      type: ppcActions.page,
      payload: {}
    });
  }, []);
  useEffect(function () {
    var arr = [];
    Object.values(page).forEach(function (x) {
      if (!app || x.clientApp === app) {
        if (itemID && cmsNavigation[itemID]) {
          if (x.internalUrl === cmsNavigation[itemID].internalUrl) arr.push(x);
        } else {
          arr.push(x);
        }
      }
    });
    setPagesArr(arr);
  }, [page, itemID]);
  useEffect(function () {
    var data = [];
    pagesArr.filter(function (x) {
      return !x.archived;
    }).forEach(function (x) {
      data.push({
        _id: x._id,
        title: x.title,
        internalUrl: x.internalUrl
      });
    });
    setTableData({
      columns: {
        id: {
          title: '_id',
          visible: false
        },
        title: 'Title',
        internalUrl: {
          title: 'URL',
          size: 'contain'
        }
      },
      data: data,
      tr: {
        onClick: function onClick(row) {
          return navigate("/".concat(app, "/page/").concat(row._id));
        }
      }
    });
  }, [pagesArr]);
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "".concat(app, " Sections"),
    button: {
      label: 'New Section',
      type: 'add',
      permission: 'edit-sections',
      onClick: function onClick() {
        dispatch({
          type: modalActions.add,
          payload: {
            component: /*#__PURE__*/React.createElement(PpcPagesAdd, {
              app: app
            })
          }
        });
      }
    },
    search: {
      query: filter,
      onChange: function onChange(e) {
        return setFilter(e.target.value);
      },
      label: 'Search Sections:',
      placeholder: 'Search...'
    }
  }), /*#__PURE__*/React.createElement(Table, _extends({}, tableData, {
    filter: filter,
    filterColumns: ['title', 'internalUrl'],
    sort: {
      by: 'title'
    }
  }))));
};
export default PagesTable;